import React from 'react';
import DefaultTermNdCondition,{VerdaTermsAndCondition} from './DefaultTermNdCondition';
import TermsAndConditions from './SharpCustomer/TermsAndConditions';
import {VERDA_CONSTS} from "../../Utils/StaticData/Constant"
export const TermsAndConditionsConfiguration=(props,customerId)=>{
    const config=new Map();
    config.set("",<DefaultTermNdCondition/>)
    config.set("HCF0999",<DefaultTermNdCondition/>)
    config.set(VERDA_CONSTS.ID,<VerdaTermsAndCondition/>)
    config.set("HCF0331",<TermsAndConditions selectedPlan={props?.selectedPlan}/>)
    let comp=config.get(customerId)
    return comp;


}